import React, { useState } from 'react'

import Checkbox from 'live/components/ui/TriStateCheckbox'
import i18n from 'live/services/i18n'

import { IAlarmsAsset } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarms'
import { IOverviewAsset } from 'plugin-codaf-risk-ext-bowtie/BowtieManagment/components/AssetSelector/AssetSelector'
import { IAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { OperationCard } from './components/OperationCard/OperationCard'
import { ResourceCardContainer } from './styles'

interface IProps {
    asset: IAlarmsAsset
    assetsSelectedBowties: Map<number, number[]>
    setAssetSelectedBowties: (operations: Map<number, number[]>) => void
    setAlarmGroup: (group: IAlarmGroup) => void
    alarmGroup: IAlarmGroup
    checkedAsset: Set<number>
}

export enum CheckboxOptions {
    ON = 'on',
    OFF = 'off',
    INDETERMINATE = 'indeterminate'
}

export const ResourceCard: React.FC<IProps> = ({
    asset,
    assetsSelectedBowties,
    setAssetSelectedBowties,
    setAlarmGroup,
    alarmGroup,
    checkedAsset
}) => {
    const [operationsVisible, setOperationsVisible] = useState<boolean>(false)

    const handleCheckedState = (): { checked: boolean; indeterminate: boolean } => {
        const bowties = asset.operations.reduce((prev, curr) => [...prev, ...curr.bowties], [])
        const arrayBowtiesSelected = Array.from(assetsSelectedBowties.values()).reduce(
            (prev, curr) => [...prev, ...curr],
            []
        ).length
        const checked = arrayBowtiesSelected === bowties.length
        const indeterminate = arrayBowtiesSelected > 0 && !checked

        if (checked) {
            checkedAsset.add(asset.id)
        } else {
            checkedAsset.delete(asset.id)
        }

        return { checked, indeterminate }
    }

    const handleAssetCheckedState = (): void => {
        const bowties = asset.operations.reduce((prev, curr) => [...prev, ...curr.bowties], [])
        const arrayBowtiesSelected = Array.from(assetsSelectedBowties.values()).reduce(
            (prev, curr) => [...prev, ...curr],
            []
        ).length
        const checked = arrayBowtiesSelected === bowties.length

        for (const operation of asset.operations) {
            assetsSelectedBowties.set(operation.id, checked ? [] : operation.bowties.map(e => e.id))
        }
        setAssetSelectedBowties(new Map([...assetsSelectedBowties.entries()]))
    }

    return (
        <ResourceCardContainer>
            <div className={'resource-name'}>
                <i
                    className={`fas fa-caret-${operationsVisible ? 'up' : 'down'}`}
                    onClick={() => {
                        setOperationsVisible(old => !old)
                    }}
                ></i>
                {asset.name.toUpperCase()}
                <Checkbox
                    {...handleCheckedState()}
                    onChange={() => handleAssetCheckedState()}
                    id="alarmgroup-bowtie-edition"
                />
            </div>
            {operationsVisible && (
                <div className={`operation-list`}>
                    {asset.operations?.map((operation, index) => (
                        <OperationCard
                            alarmGroup={alarmGroup}
                            key={index}
                            operation={operation}
                            operationSelectedBowties={assetsSelectedBowties.get(operation.id) ?? []}
                            setOperationSelectedBowties={bowties => {
                                assetsSelectedBowties.set(operation.id, bowties)
                                setAssetSelectedBowties(new Map([...assetsSelectedBowties.entries()]))
                            }}
                            setAlarmGroup={setAlarmGroup}
                        />
                    ))}
                </div>
            )}
        </ResourceCardContainer>
    )
}
